module.exports = __webpack_public_path__ + "static/media/register_mail.2d0782ac.png";